import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonPage, IonSpinner, IonToolbar, useIonAlert } from "@ionic/react"
import { PropsWithChildren, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../services/redux/hook';
import { parseDisbursementUrl } from "../../services/redux/slices/opened_disbursement_uri/parse";
import { closeOutline } from "ionicons/icons";
import AppHeader from "../../components/AppHeader/AppHeader";
import { initiateSep24Deposit } from "../../services/api/sep24";
import { Sep10ChallengeParams, WalletInfoState } from "../../types/types";
import { Networks } from "@stellar/stellar-sdk";
import { stellarApi } from "../../services/api/stellar";
import { Browser } from '@capacitor/browser';
import * as Sentry from '@sentry/react';
import { setOpenedDisbursementUri } from "../../services/redux/slices/opened_disbursement_uri/opened_disbursement_uri";
import { DisbursementUri } from "../../services/redux/slices/opened_disbursement_uri/disbursement-uri";
import { closeModal } from "../../services/redux/slices/opened_navigation_modal/opened_root_modal";
import { Provider } from "react-redux";
import { store } from "../../services/redux/store";
import { AiOutlineConsoleSql } from "react-icons/ai";


const isTestnet = import.meta.env.VITE_isTestnet === 'true' ? true : false;
const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';
const clientDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';

const Page: React.FC = () => {

    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();

    const [present] = useIonAlert();

    const presentErrorAlert = (error: any) => {

        present({
            header: 'Error',
            message: `${error.data}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const close = () => {

        dispatch(closeModal());

    }

    const ebioroAuthToken = useAppSelector((state) => state.sep10AuthToken.tokens[ebioroAuthDomain]);

    const openedDisbursementUri: string = useAppSelector((state) => state.openedDisbursementUri);

    const [disbursementUri, setDisbursementUri] = useState<DisbursementUri>();

    const [isSpinner, setIsSpinner] = useState(false);

    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);


    const proceedWithDisbursement = async () => {

        try {

            setIsSpinner(true);

            const verifiedSignature = await disbursementUri?.verifySignature();
            
            if (verifiedSignature) {

                const anchorDomain = disbursementUri?.domain as string;
                const assetCode = disbursementUri?.asset?.split('-')[0] as string;
                const account = walletInfo.account_key as string;

                const sep10Token = await getSep10Token(anchorDomain);
                
                const response = await sep24Disbursement(anchorDomain, assetCode, account, sep10Token);

                const url = response.url;

                await Browser.open({ url: url });

                close();


            }

            else {

                presentErrorAlert({ data: `The url signature is not valid.` })
            }

            setIsSpinner(false);

        } catch (error) {

            setIsSpinner(false);

            if (error instanceof Error) {
                Sentry.captureException(error);
            } else {
                Sentry.captureException(new Error(JSON.stringify(error)));
            }

        }

    }

    const getSep10Token = async (domain: string) => {

        let params: Sep10ChallengeParams;

        params = {
            account: walletInfo.account_key as string,
            home_domain: domain,
            network: isTestnet ? Networks.TESTNET : Networks.PUBLIC,
            privateKey: walletInfo.device_private_key as string,
            client_domain: clientDomain,
            client_domain_jwt: ebioroAuthToken
        }

        console.log('the params ' + JSON.stringify(params));

        const data = await dispatch(stellarApi.endpoints.sep10.initiate(params)).unwrap();

        console.log('the data ' + JSON.stringify(data));

        return data ? data[domain] : undefined
    }

    const sep24Disbursement = async (domain: string, assetCode: string, account: string, jwtToken: string) => {

        try {

              const response  = await initiateSep24Deposit(domain, assetCode, account, undefined, undefined, undefined, jwtToken);
              return response.data
            
        } catch (err: any) {
            presentErrorAlert({ data: err.message });
            Sentry.captureException(err);
            // presentErrorAlert({ data: 'We faced an error for your registration. Please try later.' });
        }

      

        // if (error) {

            
        //     return;

        // }

     

    }


    useEffect(() => {

        if (openedDisbursementUri) {

            const uri = parseDisbursementUrl(openedDisbursementUri);

            setDisbursementUri(uri)

        }

        return () => {
            dispatch(setOpenedDisbursementUri(''));
        }

    }, [openedDisbursementUri])




    return (

        <IonPage>

            <IonHeader className="ion-no-border">
                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonButtons slot='start' onClick={() => { close() }} >
                        <IonItem lines='none'>
                            <IonIcon slot='start' icon={closeOutline} color='danger' />
                        </IonItem>
                    </IonButtons>
                </IonToolbar>


                <AppHeader
                    title={t('disbursement.page.HEADER') as string}
                >
                </AppHeader>

            </IonHeader>

            <IonContent>

                <IonCard style={{ marginTop: '40%' }}>

                    <IonCardHeader>

                        <IonCardSubtitle>{t('disbursement.page.CARD-SUBHEADER')} {disbursementUri?.name}</IonCardSubtitle>
                    </IonCardHeader>

                    <IonCardContent className="ion-text-left">
                        {
                            `${disbursementUri?.name} ${t('disbursement.page.INFO')}`
                        }
                    </IonCardContent>

                </IonCard>

            </IonContent>

            <IonFooter className="ion-no-border" >
                <IonToolbar>
                    <IonButton
                        color='primary'
                        type="submit"
                        onClick={() => proceedWithDisbursement()}
                        expand="block"
                        id="pageFooterButton">
                        {isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                            :
                            t('disbursement.page.BTN.LABEL')
                        }
                    </IonButton>
                </IonToolbar>
            </IonFooter>

        </IonPage>
    )
}

const DisbursementPage: React.FC = () => (
    <Provider store={store}>
        <Page />
    </Provider>
);

export default DisbursementPage;

// export default DisbursementPage